import EditorWrapper from "./EditorWrapper";
import "./App.css";

function App() {
  return (
    <div className="App">
      <main className="Editor">
        <EditorWrapper />
      </main>
    </div>
  );
}

export default App;
